import { useRef, useCallback } from 'react';

/**
 * React 19–compatible dynamic refs hook
 * Works like the old use-dynamic-refs:
 * 
 *   const [getRef, setRef] = useDynamicRefs();
 *   <div ref={setRef('item1')} />
 *   getRef('item1').current...
 */
const useDynamicRefs = () => {
  // Store DOM nodes by key
  const refsMap = useRef(new Map());

  // Setter for attaching a ref to an element
  const setRef = useCallback((key) => (element) => {
    if (element) {
      refsMap.current.set(key, element);
    } else {
      refsMap.current.delete(key);
    }
  }, []);

  // Getter returns a real ref-like object ({ current: element })
  const getRef = useCallback((key) => {
    return {
      current: refsMap.current.get(key) || null
    };
  }, []);

  return [getRef, setRef];
};

export default useDynamicRefs;
